import React, { useState } from "react";

const media = [
  {
    url: "images/vidhya.jpeg",
    type: "image",
    date: "2026-10-23",
    caption: "വിദ്യാരംഭം",
  }, 
  {
    url: "images/newscut.jpeg",
    type: "image",
    date: "2026-10-06",
    caption: "",
  }, 
   {
    url: "images/navarathri.jpeg",
    type: "image",
    date: "2026-10-06",
    caption: "",
  }, 
  {
    url: "https://egmoreayyappantempleapms.in/images/chathurthi.jpeg",
    type: "image",
    date: "2026-10-06",
    caption: "",
  },
  {
    url: "https://egmoreayyappantempleapms.in/images/gallery.jpeg",
    type: "image",
    date: "2026-10-03",
    caption: "",
  },
  {
    url: "https://egmoreayyappantempleapms.in/images/gallery-1.jpeg",
    type: "image",
    date: "2026-10-03",
    caption: "",
  },
  {
    url: "https://egmoreayyappantempleapms.in/images/pic-15.jpeg",
    type: "image",
    date: "2026-09-28",
    caption: "",
  },
  {
    url: "https://egmoreayyappantempleapms.in/images/pic-16.jpeg",
    type: "image",
    date: "2026-09-28",
    caption: "",
  },
  {
    url: "https://egmoreayyappantempleapms.in/images/pic-17.jpeg",
    type: "image",
    date: "2026-09-28",
    caption: "",
  },
  {
    url: "https://egmoreayyappantempleapms.in/images/video-1.mp4",
    type: "video",
    date: "2026-09-20",
    caption: "",
  },
  {
    url: "https://egmoreayyappantempleapms.in/images/video-2.mp4",
    type: "video",
    date: "2026-09-20",
    caption: "Karya Sidhi Pooja",
  },
  {
    url: "https://egmoreayyappantempleapms.in/images/video-3.mp4",
    type: "video",
    date: "2026-09-15",
    caption: "Starting of Computerised Billing Software",
  },
  {
    url: "https://egmoreayyappantempleapms.in/images/video-4.mp4",
    type: "video",
    date: "2026-09-15",
    caption: "Ashta Draviya Maha Ganapathi Homam",
  },
];

function PhotoGallery() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openModal = (index) => {
    setSelectedIndex(index);
  };

  const closeModal = () => {
    setSelectedIndex(null);
  };

  const prevItem = () => {
    setSelectedIndex((prev) =>
      prev === 0 ? media.length - 1 : prev - 1
    );
  };

  const nextItem = () => {
    setSelectedIndex((prev) =>
      prev === media.length - 1 ? 0 : prev + 1
    );
  };

  // Group media by date
  const groupedMedia = media.reduce((groups, item, index) => {
    if (!groups[item.date]) {
      groups[item.date] = [];
    }

    groups[item.date].push({
      ...item,
      originalIndex: index,
    });

    return groups;
  }, {});

  // Latest date first
  const sortedDates = Object.keys(groupedMedia).sort(
    (a, b) => new Date(b) - new Date(a)
  );

  // Format date
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  return (
    <div>
      {/* Banner */}
      <div
        className="row banner"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage: "url(./images/slider/slider-1.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <div
        className="container"
        style={{
          marginTop: "50px",
          marginBottom: "50px",
        }}
      >
        {sortedDates.map((date) => (
          <div key={date} style={dateSectionStyle}>
            {/* Date Heading */}
            <div style={dateHeadingStyle}>
              <h2 style={{fontSize:"15pt",fontWeight:'600'}}>{formatDate(date)}</h2>
            </div>

            {/* Gallery */}
            <div style={galleryStyle}>
              {groupedMedia[date].map((item) => (
                <div
                  key={item.originalIndex}
                  style={cardStyle}
                  onClick={() => openModal(item.originalIndex)}
                >
                  <div style={mediaContainerStyle}>
                    {item.type === "image" ? (
                      <img
                        src={item.url}
                        alt={item.caption}
                        style={imgStyle}
                      />
                    ) : (
                      <video
                        src={item.url}
                        style={videoStyle}
                        muted
                        playsInline
                      />
                    )}

                    {/* Video Badge */}
                    {item.type === "video" && (
                      <div style={videoBadgeStyle}>
                        ▶ Video
                      </div>
                    )}
                  </div>

                  {/* Caption */}
                  <div style={captionStyle}>
                    {item.caption}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedIndex !== null && (
        <div style={modalOverlay} onClick={closeModal}>
          <div
            style={modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close */}
            <span
              style={closeBtn}
              onClick={closeModal}
            >
              ×
            </span>

            {/* Previous */}
            <button
              style={navBtnLeft}
              onClick={prevItem}
              aria-label="Previous"
            >
              ❮
            </button>

            {/* Media */}
            <div style={modalMediaWrapper}>
              {media[selectedIndex].type === "image" ? (
                <img
                  src={media[selectedIndex].url}
                  alt={media[selectedIndex].caption}
                  style={modalMedia}
                />
              ) : (
                <video
                  src={media[selectedIndex].url}
                  controls
                  autoPlay
                  style={modalMedia}
                />
              )}

              {/* Modal Caption */}
              <div style={modalCaption}>
                {media[selectedIndex].caption}
              </div>

              {/* Modal Date */}
              <div style={modalDate}>
                {formatDate(media[selectedIndex].date)}
              </div>
            </div>

            {/* Next */}
            <button
              style={navBtnRight}
              onClick={nextItem}
              aria-label="Next"
            >
              ❯
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

/* =========================
   GALLERY STYLES
========================= */

const dateSectionStyle = {
  marginBottom: "50px",
};

const dateHeadingStyle = {
  marginBottom: "20px",
  borderBottom: "2px solid #eee",
  paddingBottom: "10px",
  
};



const galleryStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
  gap: "20px",
};

const cardStyle = {
  backgroundColor: "#fff",
  borderRadius: "10px",
  overflow: "hidden",
  cursor: "pointer",
  boxShadow: "0 3px 12px rgba(0,0,0,0.12)",
  transition: "transform 0.2s ease",
};

const mediaContainerStyle = {
  position: "relative",
  height: "220px",
  overflow: "hidden",
};

const imgStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
};

const videoStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
};

const captionStyle = {
  padding: "12px 15px",
  fontSize: "15px",
  fontWeight: "500",
  color: "#333",
  minHeight: "45px",
};

const videoBadgeStyle = {
  position: "absolute",
  bottom: "10px",
  left: "10px",
  backgroundColor: "rgba(0,0,0,0.7)",
  color: "#fff",
  padding: "5px 10px",
  borderRadius: "5px",
  fontSize: "12px",
};

/* =========================
   MODAL
========================= */

const modalOverlay = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.92)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
  padding: "20px",
};

const modalContent = {
  position: "relative",
  width: "90%",
  maxWidth: "1000px",
  maxHeight: "95vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modalMediaWrapper = {
  textAlign: "center",
  width: "100%",
};

const modalMedia = {
  maxWidth: "100%",
  maxHeight: "75vh",
  objectFit: "contain",
  borderRadius: "5px",
};

const modalCaption = {
  color: "#fff",
  fontSize: "18px",
  fontWeight: "500",
  marginTop: "15px",
};

const modalDate = {
  color: "#ccc",
  fontSize: "14px",
  marginTop: "5px",
};

const closeBtn = {
  position: "absolute",
  top: "-45px",
  right: "0",
  fontSize: "35px",
  color: "#fff",
  cursor: "pointer",
  zIndex: 10,
};

const navBtnLeft = {
  position: "absolute",
  left: "-60px",
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: "35px",
  background: "none",
  border: "none",
  color: "#fff",
  cursor: "pointer",
  zIndex: 10,
};

const navBtnRight = {
  position: "absolute",
  right: "-60px",
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: "35px",
  background: "none",
  border: "none",
  color: "#fff",
  cursor: "pointer",
  zIndex: 10,
};

export default PhotoGallery;